/**
 * The workspace under an expanded service: "log time manually" on the left,
 * `actions` on the right (Pause + Finish while running, nothing while
 * paused — Resume sits in the header).
 *
 * Used to also carry the service's own notes (add / edit / delete own,
 * through the per-service note endpoints). Removed 2026-09-22 — a mechanic
 * writes one note per job now, on the job page's WoJobNotes panel, not one
 * per service. Two note boxes on a job page was one too many for a
 * mechanic who is not comfortable with software.
 *
 * Parts are not here: they belong to the SERVICE and are listed once on
 * its card.
 */
import { useState } from 'react'
import { ManualLabourModal } from './ManualLabourModal'
import { useI18n } from '@/i18n/TranslationContext'

interface Props {
  /** The service's step — where the backend keeps its time. */
  readonly serviceId: string
  readonly actions: React.ReactNode
  /** Manual time can be logged while the timer runs, is paused, or has not
   *  started; a finished or unowned service is read-only. */
  readonly canWrite: boolean
}

export function WoServiceWorkspace({ serviceId, actions, canWrite }: Props) {
  const { t } = useI18n()
  const [manualOpen, setManualOpen] = useState(false)

  if (!canWrite) return null

  return (
    <div className="px-4 py-3">
      {/* log time (left) · state-specific actions (right) */}
      <div className="flex items-center justify-between gap-3">
        <button type="button" onClick={() => setManualOpen(true)} className="text-11 italic text-glass-text-muted underline decoration-glass-text-muted/50 hover:text-glass-text">
          {t.workOrder.logTimeManually}
        </button>
        <div className="flex items-center gap-2">{actions}</div>
      </div>

      <ManualLabourModal open={manualOpen} serviceId={serviceId} onClose={() => setManualOpen(false)} />
    </div>
  )
}
